import { configureStore } from "@reduxjs/toolkit";

import { rootApi } from "@/store/services/root-api";
import { userReducer } from "@/store/slices/user.slice";

/**
 * Create and configure redux store using the `configureStore` (more info: https://redux.js.org/usage/configuring-your-store)
 */
export const store = configureStore({
    reducer: {
        [rootApi.reducerPath]: rootApi.reducer,
        user: userReducer,
    },
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(rootApi.middleware),
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers(), // explicitly use `getDefaultEnhancers()`
});

/**
 * Infer the `RootState` type from the store
 */
export type RootState = ReturnType<typeof store.getState>;
/**
 * Infer the `AppDispatch` type from the store
 */
export type AppDispatch = typeof store.dispatch;
